// extracted by mini-css-extract-plugin
export default {"back":"DepGarItem_back__cPEK6","nombre":"DepGarItem_nombre__AgekT","otros":"DepGarItem_otros__NVML8","divBotones":"DepGarItem_divBotones__mAOwO","innbtn":"DepGarItem_innbtn__aIDal"};